var map = {
	"./arrow-backwards.svg": 1531,
	"./arrow-forward_outlined.svg": 8251,
	"./bucher-light.svg": 4787,
	"./bucher.svg": 4392,
	"./chat-bubble_outlined.svg": 7397,
	"./chevron-backwards_outlined.svg": 8046,
	"./chevron-forwards_outlined.svg": 4708,
	"./circle-arrow-left.svg": 1779,
	"./circle-arrow-right.svg": 7638,
	"./close_outlined.svg": 646,
	"./delete.svg": 2814,
	"./description.svg": 5563,
	"./download_outlined.svg": 6864,
	"./expand-less_outlined.svg": 2220,
	"./expand-more_outlined.svg": 4348,
	"./eye-closed.svg": 8231,
	"./filter-list.svg": 4830,
	"./mail_outlined.svg": 6747,
	"./navigation_outlined.svg": 5366,
	"./search.svg": 891,
	"./search_outlined.svg": 6752,
	"./telephone_outlined.svg": 7842,
	"./times.svg": 4135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 862;